import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import es from '@angular/common/locales/es';
import { LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';
registerLocaleData(es);

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { Select2Module } from 'ng-select2-component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TestCitaComponent } from './components/public/test-cita/test-cita.component';

import { AdminLayoutComponent, DistributorLayoutComponent, PublicLayoutComponent } from './containers';
import { HeadercontentComponent } from './components/public/shared/headercontent/headercontent.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Helpers } from './helpers/helpers';
import { InterceptorService } from './services/interceptor.service';

const APP_CONTAINERS = [
  AdminLayoutComponent,
  PublicLayoutComponent,
  DistributorLayoutComponent
];

@NgModule({
  declarations: [
    HeadercontentComponent,
    AppComponent,
    TestCitaComponent,
    ...APP_CONTAINERS
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    NgbModule,
    ToastrModule.forRoot(),
    Select2Module
  ],
  providers: [
    Helpers,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
